import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { STUDIES_ROUTES } from './studies.routes';
import { PRIVILEGE_SECTIONS } from '../../core/dashboard-constants';
import { StudiesComponent } from './pages/studies/studies.component';
import { StudyDetailsComponent } from './pages/study-details/study-details.component';
import { SubscriptionComponent } from './pages/subscription/subscription.component';
import { StudyHomeComponent } from './pages/study-home/study-home.component';
import { InterventionsComponent } from './pages/interventions/interventions.component';
import { InformativePagesComponent } from './pages/informative-pages/informative-pages.component';
import { ModulesComponent } from './pages/modules/modules.component';
import { StudyResearchersComponent } from './pages/study-researchers/study-researchers.component';
import { PrivilegesGuard } from '../../core/guards/privileges/privileges.guard';
import { CalculatedVariablesComponent } from './pages/calculated-variables/calculated-variables.component';
import { TemplatesComponent } from './pages/templates/templates.component';
import { TiimStudyParticipantsComponent } from './pages/study-participants/tiim-study-participants/tiim-study-participants.component';
import { CcStudyParticipantsComponent } from './pages/study-participants/cc-study-participants/cc-study-participants.component';
import { EmailPagesComponent } from './pages/email-pages/email-pages.component';
import { MetricsComponent } from './pages/metrics/metrics.component';

const routes: Routes = [
  {
    path: `:id/${STUDIES_ROUTES.HOME}`,
    component: StudyHomeComponent,
    data: { breadcrumb: 'STUDY HOME' },
  },
  {
    path: `:id/${STUDIES_ROUTES.DETAILS}`,
    component: StudyDetailsComponent,
    canActivate: [PrivilegesGuard],
    data: {
      breadcrumb: 'STUDY DETAILS',
      section: PRIVILEGE_SECTIONS.STUDY_DETAILS,
    },
  },
  {
    path: STUDIES_ROUTES.CREATE_STUDY,
    component: StudyDetailsComponent,
    canActivate: [PrivilegesGuard],
    data: {
      breadcrumb: 'CREATE STUDY',
      section: PRIVILEGE_SECTIONS.STUDY_DETAILS,
    },
  },
  {
    path: `:id/${STUDIES_ROUTES.SUBSCRIPTION}`,
    component: SubscriptionComponent,
    data: { breadcrumb: 'SUBSCRIPTION' },
  },
  {
    path: `:id/${STUDIES_ROUTES.INTERVENTIONS}`,
    component: InterventionsComponent,
    canActivate: [PrivilegesGuard],
    data: {
      breadcrumb: 'INTERVENTIONS',
      section: PRIVILEGE_SECTIONS.INTERVENTIONS,
    },
  },
  {
    path: `:id/${STUDIES_ROUTES.SESSIONS}`,
    component: InterventionsComponent,
    canActivate: [PrivilegesGuard],
    data: { breadcrumb: 'SESSIONS', section: PRIVILEGE_SECTIONS.INTERVENTIONS },
  },
  {
    path: `:id/${STUDIES_ROUTES.INFORMATIVE_PAGES}`,
    component: InformativePagesComponent,
    data: { breadcrumb: 'INFORMATION' },
  },
  {
    path: `:id/${STUDIES_ROUTES.MODULES}`,
    component: ModulesComponent,
    canActivate: [PrivilegesGuard],
    data: {
      breadcrumb: 'MODULES',
      section: PRIVILEGE_SECTIONS.MODULES,
    },
  },
  {
    path: `:id/${STUDIES_ROUTES.TIIM_PARTICIPANTS}`,
    component: TiimStudyParticipantsComponent,
    canActivate: [PrivilegesGuard],
    data: {
      breadcrumb: 'PARTICIPANTS',
      section: PRIVILEGE_SECTIONS.PARTICIPANTS,
    },
  },
  {
    path: `:id/${STUDIES_ROUTES.CC_PARTICIPANTS}`,
    component: CcStudyParticipantsComponent,
    canActivate: [PrivilegesGuard],
    data: {
      breadcrumb: 'PARTICIPANTS',
      section: PRIVILEGE_SECTIONS.PARTICIPANTS,
    },
  },
  {
    path: `:id/${STUDIES_ROUTES.METRICS}`,
    component: MetricsComponent,
    canActivate: [PrivilegesGuard],
    data: {
      breadcrumb: 'METRICS',
      section: PRIVILEGE_SECTIONS.METRICS,
    },
  },
  {
    path: `:id/${STUDIES_ROUTES.RESEARCHERS}`,
    component: StudyResearchersComponent,
    canActivate: [PrivilegesGuard],
    data: {
      breadcrumb: 'RESEARCHERS',
      section: PRIVILEGE_SECTIONS.RESEARCHERS,
    },
  },
  {
    path: `:id/${STUDIES_ROUTES.CALCULATED_VARIABLES}`,
    component: CalculatedVariablesComponent,
    data: { breadcrumb: 'CALCULATED VARIABLES' },
  },
  {
    path: `:id/${STUDIES_ROUTES.TEMPLATES}`,
    component: TemplatesComponent,
    data: { breadcrumb: 'TEMPLATES' },
  },
  {
    path: `:id/${STUDIES_ROUTES.EMAILS}`,
    component: EmailPagesComponent,
    data: { breadcrumb: 'EMAILS' },
  },
  {
    path: STUDIES_ROUTES.ROOT,
    component: StudiesComponent,
    data: { breadcrumb: ' ' },
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StudiesRoutingModule {}
